// v9 compat packages are API compatible with v8 code
import {initializeApp} from 'firebase/app';
import {getAuth} from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';
// import firebase from 'firebase/app';
// import {initializeApp} from 'firebase/app';
// import { getAnalytics } from "firebase/analytics";
// import {getAuth} from 'firebase/compat/auth';
// import firebase from 'firebase/app';

// const firebase = require("firebase");
// Required for side-effects
// require("firebase/firestore");

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var firebaseConfig = {
  apiKey: "AIzaSyDcrrIoLQBUfRydGNrkO609VorWvl0s6LU",
  authDomain: "raidhiveteam-user-auth.firebaseapp.com",
  projectId: "raidhiveteam-user-auth",
  storageBucket: "raidhiveteam-user-auth.appspot.com",
  messagingSenderId: "795947686663",
  appId: "1:795947686663:web:ebecd12c8286df29df03a2",
  measurementId: "G-YSEC4M231F"
};

// Initialize Firebase
 const firebaseApp = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
